module.controller('sampleExportCtrl', [ '$scope', '$rootScope', '$state', 'birtService', 'planSamplingService', 'alertService', sampleExportCtrlFn ]);
function sampleExportCtrlFn($scope, $rootScope, $state, birtService, planSamplingService, alertService) {
	var vm = $scope;
	
	vm.filters = {
		client:{selected:[]},
		datePicker: {},
		dateType: true
	}
	
	/*
	 * Opciones del datepicker
	 */
	vm.opts = {
		locale : {
			applyClass : 'btn-green',
			applyLabel : "Elegir",
			fromLabel : "desde",
			format : "YYYY-MM-DD",
			toLabel : "a",
			cancelLabel : 'Cancelar',
			customRangeLabel : 'Personalizado'
		},
		ranges : {
			'Sin fecha' : [ '', '' ],
			'Últimos 7 dias' : [ moment().subtract(6, 'days'), moment() ],
			'Últimos 30 dias' : [ moment().subtract(29, 'days'), moment() ],
			'Este mes' : [ moment().startOf('month'), moment().endOf('month') ]
		},
		autoApply : true,
		eventHandlers : {
			'apply.daterangepicker' : onApplyDatePicker
		}
	};

	
	vm.export = function(){
		var clientId = undefined, stateId = undefined, takeDStart = undefined, takeDEnd = undefined;
		var analysisDStart = undefined, analysisDEnd = undefined;
		
		if(hasData(vm.filters.client))
			clientId = vm.filters.client.selected[0].id;
		if(hasData(vm.filters.states)){
			stateId = [];
			vm.filters.states.selected.forEach(function(s){stateId.push(s.id);});
		}
		// fecha de toma
		if(vm.filters.dateType){
			takeDStart = vm.filters.datePicker.startDate;
			takeDEnd = vm.filters.datePicker.endDate;
		}else{
			analysisDStart = vm.filters.datePicker.startDate;
			analysisDEnd = vm.filters.datePicker.endDate;
		}
		
		var dlnk = document.getElementById('linkExport');
		dlnk.href = birtService.exportExcel(clientId, stateId, takeDStart, takeDEnd, analysisDStart, analysisDEnd);
		dlnk.click();
	}
	
	vm.clean =  function(){
		vm.filters = {
				client:{selected:[]},
				datePicker: {},
				dateType: true
			}
	}
	
	vm.pruebasRefreshViews =  function(){
		planSamplingService.pruebasrefreshviews().then(function(){
			alertService.showSuccess("se actualizan vistas");
		}, function(){});
	}
	
	function hasData(data){
		if(angular.isUndefined(data))
			return false;
		if(angular.isUndefined(data.selected) || data.selected == null || data.selected.length <= 0)
			return false;
		return true;
	}
	

	/**
	 * Eventos Datepicker
	 */
	function onApplyDatePicker(ev, picker) {
		console.log("date apply");
		console.log(ev);
		console.log(picker);
		console.log(vm.filters);
		if(angular.isUndefined(vm.filters.datePicker.startDate)){
			vm.filters.datePicker.startDate = moment();
		}
		if(angular.isUndefined(vm.filters.datePicker.endDate)){
			vm.filters.datePicker.endDate = moment();
		}
	}
}